export default __webpack_public_path__ + "static/media/teaching-faculty.23da5753.webp";